<template>
  <a-form-model
    class="fromStyle"
    ref="ruleForm"
    :model="ruleForm"
    :rules="rules"
    v-bind="formItemLayout"
  >
    <a-form-model-item v-if="ruleForm.type == 1" label="姓名" prop="name">
      <a-input v-model="ruleForm.name" />
    </a-form-model-item>
    <a-form-model-item label="公司">
      <a-select
        @change="changeThirdVal"
        v-model="ruleForm.company_id"
        showSearch
        :filterOption="filterOption"
        placeholder="请选择所在公司"
      >
        <a-select-option
          v-for="(item, j) in thirdList"
          :key="j + 'l'"
          :value="item.id"
          >{{ item.name }}</a-select-option
        >
      </a-select>
    </a-form-model-item>
    <a-form-model-item v-if="ruleForm.type == 1" label="联系电话" prop="phone">
      <a-input v-model="ruleForm.phone" />
    </a-form-model-item>
    <a-form-model-item label="岗位" prop="role_id_list">
      <a-select
        showSearch
        :filterOption="filterOption"
        mode="multiple"
        optionFilterProp="children"
        v-model="ruleForm.role_id_list"
        placeholder="请选择岗位名称"
      >
        <a-select-option
          v-for="(item, i) in roleList"
          :key="i"
          :value="item.id"
          >{{ item.role_name }}</a-select-option
        >
      </a-select>
    </a-form-model-item>
    <a-form-model-item has-feedback label="关联项目">
      <a-select
        :maxTagCount="10"
        style="width: 86%; margin-right: 10px"
        showSearch
        :filterOption="filterOption"
        mode="multiple"
        v-model="ruleForm.project_list"
        placeholder="请选择关联项目"
      >
        <a-select-option
          v-for="(item, i) in thirdProList"
          :key="i + 'b'"
          :value="item.project_id"
          >{{ item.project_name }}</a-select-option
        >
      </a-select>
      <span>
        <a-checkbox @change="selectedAllThree">全选</a-checkbox>
      </span>
    </a-form-model-item>
    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
      <!-- <a-button style="margin-right: 10px" @click="resetForm('ruleForm')">
        重置
      </a-button> -->
      <a-button type="primary" @click="submitForm('ruleForm')">
        提交
      </a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      ruleForm: {
        type: 1,
        company_id: "",
        name: "",
        phone: "",
        contact_phone: "",
        contact_name: "",
        role_id_list: [],
        project_list: []
      },
      rules: {
        company_id: [
          { required: true, trigger: "change", message: "请选择公司名称" }
        ],
        name: [{ required: true, trigger: "blur", message: "请填写姓名" }],
        phone: [
          { required: true, trigger: "blur", message: "请填写手机号码" },
          {
            len: 11,
            message: "请填写正确的手机号码格式",
            trigger: "blur"
          }
        ],
        role_id_list: [
          { required: true, trigger: "change", message: "请选择岗位" }
        ]
      },
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 12 }
      },
      roleList: [],
      thirdProList: [],
      thirdList: [],
      details: ""
    };
  },
  mounted() {
    if (this.editDetail != undefined) {
      this.getDetails();
    }
    this.getRoleList(); //获取岗位列表
    this.getThirdParty(); //获取三方公司
    this.changeThird(); //获取三方公司关联项目
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.getDetails();
    }
  },
  methods: {
    getThirdParty() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Third_part/thirdPartList";
      let pramas = {
        per_page: 10000,
        type: 1,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.thirdList = res.data.data.data;
          // console.log(this.thirdList);
        }
      });
    },
    getDetails() {
      this.details = this.editDetail;
      // console.log(this.details);
      let role_info = [];
      if (this.details.role_info != undefined && this.details.role_info != "") {
        this.details.role_info.forEach(element => {
          role_info.push(element.id);
        });
      }
      let projectIDs = [];
      if (
        this.details.entry_info != undefined &&
        this.details.entry_info != ""
      ) {
        this.details.entry_info.forEach(element => {
          projectIDs.push(element.id);
        });
      }
      this.ruleForm = {
        type: this.details.type,
        name: this.details.user_name,
        phone: this.details.phone,
        role_id_list: role_info,
        project_list: projectIDs,
        company_id: this.details.resume_third_part_id
      };
      this.changeThird();
      // console.log(this.details);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //   alert("submit!");
          let url =
            this.httpsBasic.url +
            this.httpsBasic.user +
            "User/editCompanyChannelUser";
          let projectList = [];
          if (
            this.ruleForm.project_list != "" &&
            this.ruleForm.project_list != undefined
          ) {
            this.ruleForm.project_list.forEach(element => {
              projectList.push({
                project_id: element
              });
            });
          }
          let pramas = {
            user_id: this.details.id,
            role_id_list: JSON.stringify(this.ruleForm.role_id_list),
            user_name: this.ruleForm.name,
            phone: this.ruleForm.phone,
            token: window.localStorage.getItem("xnwfPcToken"),
            project_list: JSON.stringify(projectList),
            company_id: this.ruleForm.company_id
          };
          if (
            this.ruleForm.project_list == "" ||
            this.ruleForm.project_list == undefined
          ) {
            delete pramas.project_list;
          }
          // console.log(pramas);
          axios
            .post(url, pramas)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.resetForm("ruleForm");
                this.$emit("hideInEdit", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm = {
        type: 1,
        company_id: "",
        name: "",
        phone: "",
        contact_phone: "",
        contact_name: "",
        role_id_list: [],
        project_list: []
      };
    },
    changeThirdVal() {
      this.ruleForm.project_list = [];
      this.changeThird();
    },
    changeThird() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Third_part/getProjectInfoByThirdId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          resume_third_part_id: this.ruleForm.company_id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.thirdProList = res.data.data;
          }
          // console.log(res.data.data);
        });
    },
    selectedAllThree(e) {
      this.ruleForm.project_list = [];
      if (e.target.checked) {
        this.thirdProList.forEach(element => {
          this.ruleForm.project_list.push(element.project_id);
        });
      } else {
        this.ruleForm.project_list = [];
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getRoleList() {
      const url = this.httpsBasic.url + this.httpsBasic.user + "User/roleList";
      const pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 100000,
        role_type: 1
      };
      axios
        .post(url, pramas)
        .then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            this.roleList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    }
  }
};
</script>
<style lang="less" scoped>
.fromStyle {
  padding: 30px 4% 50px;
}
</style>
<style lang="less">
.fromStyle {
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
  }
  .area-select {
    line-height: 32px;
  }
  .area-select.medium {
    width: 142px;
  }
  .ant-form-item {
    margin-bottom: 14px;
  }
}
</style>
